const trainingGetters = {
  getTraining: (state) => state.training,
  getTrainings: (state) => state.trainings,
  getQuestions: (state) => state.questions,
  getBTrainings: (state) => state.bTrainings,
  getBTraining: (state) => state.bTraining,
  getBTrainingTypes: (state) => state.bTrainingTypes,
  getBTrainingCosts: (state) => state.bTrainingCosts,
  getBTrainingDetails: (state) => state.bTrainingsDetails,
  getTrainingResults: (state) => state.trainingResults,
  getBTrainingResults: (state) => state.bTrainingResults,
  getExternalTrainingResults: (state) => state.externalTrainingResults,
  getHunterResults: (state) => state.hunterResults,
  getHunterDetails: (state) => state.hunterDetails,
  getHunterDetail: (state) => state.hunterDetail,
  getUberallList: (state) => state.uberallResults,
  getCertificateTexts: (state) => state.certificateTexts,
  getTrainingFilters: (state) => state.trainingFilters
}

export { trainingGetters }
